<script>
import {
  showModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import * as m from '@app/paraglide/messages.js';

/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();

function handleToggleMenu() {
  toggleMenu('timecode');
}

async function trimToDuration(){
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        try {
            if (eventGroupState[projectState.selected].events[eventIndex].audioFile && !isNaN(eventGroupState[projectState.selected].events[eventIndex].audioFileDuration)){
                eventGroupState[projectState.selected].events[eventIndex].end = eventGroupState[projectState.selected].events[eventIndex].start + eventGroupState[projectState.selected].events[eventIndex].audioFileDuration+0.5;
            }            
        } catch(err){
            console.log(err.message, err);
        }
        
    });
}

function clearTimecodes(){
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        try {
            eventGroupState[projectState.selected].events[eventIndex].start = false;
            eventGroupState[projectState.selected].events[eventIndex].end = false;
        } catch(err){
            console.log(err.message, err);
        }
        
    });
}

function addOneFrame() {
    const frameDuration = 1 / projectState.frameRate;
    
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        try {
            if (eventGroupState[projectState.selected].events[eventIndex].end !== false) {
                eventGroupState[projectState.selected].events[eventIndex].end += frameDuration;
            }
        } catch(err) {
            console.log(err.message, err);
        }
    });
}

function subtractOneFrame() {
    const frameDuration = 1 / projectState.frameRate;
    
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        try {
            const event = eventGroupState[projectState.selected].events[eventIndex];
            if (event.end !== false && event.start !== false) {
                // Ensure end time doesn't go below start time
                const newEnd = event.end - frameDuration;
                if (newEnd > event.start) {
                    event.end = newEnd;
                }
            }
        } catch(err) {
            console.log(err.message, err);
        }
    });
}
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
    <a onclick={handleToggleMenu} class="dropdown-toggle nav-link" href="#!/" id="timecodeMenu" aria-haspopup="true" aria-expanded={currentState}>{m.timecode()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" aria-labelledby="timecodeMenu" role="menu">
        <!-- Project Incode and Frame Rate -->
        <a class="dropdown-item" href="#!/" onclick={() => showModal("projectTimingSettings")} role="menuitem" id="projectSettingsBtn">{m.project_settings()}</a>
        <!-- Convert Time Code -->
        <a class="dropdown-item" href="#!/" onclick={() => showModal("convertTimecode")} role="menuitem" id="convertTimecodeBtn">{m.convert_timecode()}</a>
        <!-- Timecode Offset -->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={() => showModal("tcOffset")} role="menuitem" id="tcOffsetBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}>{m.timecode_offset()}</a>
        
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={() => showModal("timeStretch")} role="menuitem" id="timeStretchBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}>{m.stretch_shrink()}</a>

        <!-- Auto Correct Timing -->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].events.length > 0 ? '' : 'disabled'}" href="#!/" onclick={() => showModal("autoCorrectTiming")} role="menuitem" id="autoCorrectBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].events.length}>{m.auto_correct_reading_speed()}</a>

        <a class="dropdown-item {eventGroupState.length < 2 ? 'disabled' : ''}" href="#!/" onclick={() => showModal("copyTcFromGroup")} role="menuitem" id="copyTcBtn" aria-disabled={eventGroupState.length < 2}>{m.copy_tc_from_group()}</a>
        {#if eventGroupState[projectState.selected] && eventGroupState[projectState.selected].type === 'audio description'}
            <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={trimToDuration} role="menuitem" id="trimDurationBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}>{m.trim_to_duration()}</a>
        {/if}
        <hr class="dropdown-divider">
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={subtractOneFrame} role="menuitem" id="subtractOneFrameBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}><i class="bi bi-dash"></i> {m.subtract_one_frame()}</a>
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={addOneFrame} role="menuitem" id="addOneFrameBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}><i class="bi bi-plus"></i> {m.add_one_frame()}</a>
        <hr class="dropdown-divider">
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" href="#!/" onclick={clearTimecodes} role="menuitem" id="clearTcBtn" aria-disabled={!eventGroupState[projectState.selected] || !eventGroupState[projectState.selected].selected.length}>{m.clear_timecodes()}</a>
    </div>
</li>
